<template>
    <option :value="optionData.kpi_problem_cause_id">{{ optionData.name }}</option>
    <!--&nbsp; &nbsp; &nbsp; &nbsp; <problem-option v-for="child in getChildren(optionData)" :optionData="child" :key="child.uid"></problem-option>-->
</template>

<script>
    export default {
      name: "ProblemOption",
      props: ["optionData"],
      methods: {
        getChildren: function (parent) {
          if(typeof parent.children === 'undefined'){
            return [];
          }else {
            return parent.children;
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ProblemOption.vue